import emptyInnerHTML from '@/common/helpers/empty-inner-html';
import timezone from '@/common/timezone';
import {DateTimeFormats} from '@/common/datetime-formats';
import Moment from 'moment';

/**
 * Format by default date format
 * Without transformation to utc or to client (basic formatting)
 *
 * @param value
 * @param format
 * @return {*}
 */
function date(value, format) {
    if (!value) {
        return emptyInnerHTML;
    }

    if (!value.format) {
        value = Moment(value);
    }

    return value.format(DateTimeFormats[format] || format);
}

/**
 * Format date in templates
 * read value as UTC -> string
 *
 * @param value
 * @param {string} format - timezone.DateTimeFormats
 * @return {*}
 */
export const dateUTC = (
    value,
    format = DateTimeFormats.datetime,
) => date(value ? timezone.readUTC(value) : null, format);

/**
 * Basic local date format
 * read value as Local -> string
 *
 * in templates
 */
export const dateLocal = (
    value,
    format = DateTimeFormats.date,
) => date(value ? timezone.readLocalDate(value) : null, format);

/**
 * Format by default datetime format
 * read value as UTC -> string
 *
 * @param value
 * @return {*}
 */
export const dateTime = value => dateUTC(value);

/**
 * Format date in templates
 * read value as UTC -> string
 *
 * @param value
 * @param {string} tz
 * @param {string} format - timezone.DateTimeFormats
 * @return {*}
 */
export const tzDate = (
    value,
    tz,
    format = DateTimeFormats.date,
) => date(
    value
        ? Moment.utc(value).tz(tz)
        : null,
    format,
);

/**
 * Format by default time format
 * read value as UTC -> string
 *
 * @param value
 * @return {*}
 */
export const time = value => dateUTC(value, DateTimeFormats.time);


/**
 * Format input date (ignore timezone)
 *
 * UTC->UTC
 * local->local
 *
 * @param value
 * @param format
 * @returns {*}
 */
export const dateFormat = (value, format = DateTimeFormats.date) => date(value, format);
